import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  ApproveOfferResponseSchema,
  ConfirmationPreviewResponseSchema,
} from '../schemas/campaign-sale.js';
import { OfferIdSchema, OfferSchema, OfferStatusSchema } from '../schemas/offer.js';

export const SetOfferStatusBodySchema = z
  .object({
    targetStatus: OfferStatusSchema,
    reason: z.string().min(5).max(500),
  })
  .strict();
export type SetOfferStatusBody = z.infer<typeof SetOfferStatusBodySchema>;

export const offerApproval = {
  approve: endpoint(
    'POST',
    '/offers/:id/approve',
    z.object({ id: OfferIdSchema }).strict(),
    ApproveOfferResponseSchema,
  ),
  // GET /offers/:id/confirmation-preview (offer-approval / "Campaign
  // confirmation preview"). No query params — same style as
  // campaignSale.salePreview.
  confirmationPreview: endpoint(
    'GET',
    '/offers/:id/confirmation-preview',
    z.object({ id: OfferIdSchema }).strict(),
    ConfirmationPreviewResponseSchema,
  ),
  setStatus: endpoint(
    'POST',
    '/offers/:id/set-status',
    z.object({ id: OfferIdSchema }).merge(SetOfferStatusBodySchema),
    OfferSchema,
  ),
};
